import React, {useContext, useEffect, useState} from 'react'
import Data from './Data'
import Payments from './Payments'
import { LawyerContext, LoadingContext } from '../../../partials/Context'
import {Errors} from '../../../partials/Partials'

function Oplac() {
    const [services, setServices] = useState([]);
    const lawyer = useContext(LawyerContext);
    const [lawyer_data, setLawyerData] = useState({});
    const {id} = lawyer || ''
    const [payment_data, setPaymentData] = useState({});
    const {setLoading} = useContext(LoadingContext)
    const [errors, setErrors] = useState([])

    const pathname = window.location.pathname

    const current_id = id

    const token = pathname.split('/')[2]

    const getLawyerData = () => {
      fetch(`/api/lawyer_profiles_extended/${current_id}`, {headers: {
                'Authorization': `Token ${token}`,
            }}).then(res => {
      if (res.ok) {
        res.json().then(
          data => {
              setLawyerData(data)
              setLoading(false)
          }
        )
      } else {
        setErrors(['Nie udało się pobrać danych'])
        setLoading(false)
      }
    })
    }

    const setPaymentTurnedOff = () => void 0;


    useEffect(() => {
    if (id) {
      setLoading(true)
      getLawyerData()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[id])

    useEffect(() => {
      setLoading(true)
        fetch('/api/przelewy24/lawyer-services', {headers: {
                'Authorization': `Token ${token}`,
            }}).then(res => {
          if (res.ok) {
            res.json().then(data => {
            setServices(data.available_services)
            setLoading(false)
            })
          } else {
            setErrors(['Nie udało się pobrać danych'])
            setLoading(false)
          }
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  return (
    <>
    <div className="prawnik-portfel">
        <div className="portfel-content">
          <Errors errors={errors}/>
            <Data lawyer_data={lawyer_data} lawyer={lawyer} setPaymentData={setPaymentData} payment_data={payment_data} token={token}/>
            <Payments services={services} payment_data={payment_data} id={id} has_recurring_payment_on={false} getLawyerData={getLawyerData} setPaymentTurnedOff={setPaymentTurnedOff} token={token}/>
        </div>
    </div>
    </>
  )
}

export default Oplac